export default __webpack_public_path__ + "static/char-s-41-en-a961636cbfce70dfcc11881448bcd1b1.png";